export const WHITE = 'white';
export const DEFAULT = 'default';
export const WHITE_COLOR = 'whiteColor';
export const SIMPLE_WHITE = 'simpleWhite';
export const GREY = 'grey';
export const BLACK = 'black';
export const BLACK_COLOR = 'blackColor';